<template>
  <div v-bind:style="{ height: height + 'px' }">
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title>
          <div style="display:table;">
            <div style="display:table-cell;vertical-align: middle;">
              <img
                width="50px"
                src="https://appmedia.jp/wp-content/uploads/2018/11/5fa38350c8f3913fd3b48b067e28dd6d.png"
              >
            </div>
            <div style="display:table-cell;vertical-align: middle;">
              <span>フレンド募集/編成投稿掲示板管理 Ver1.50</span>
            </div>
          </div>
        </v-toolbar-title>
        <div>
          <v-autocomplete
            v-model="category"
            :items="Object.keys(categoryItems)"
            outlined
            dense
            item-value="value"
            label="カテゴリ"
            class="mt-6 ml-2"
            @change="selected()"
          ></v-autocomplete>
        </div>
        <div>
          <v-autocomplete
            v-model="article_num"
            :items="selectedItem"
            outlined
            dense
            label="記事番号"
            class="mt-6 ml-2"
            @change="dataSearch()"
          ></v-autocomplete>
        </div>

        <div v-if="article_num != '' && article_num != '全コメント' && article_num != '通報されたコメント'">
          <v-btn
            color="red darken-4"
            dark
            class="mb-2"
            @click="cacheClear()"
            style="margin-left:20px;"
          >
            <v-icon>mdi mdi-alpha-c-circle</v-icon>キャッシュ削除
          </v-btn>
        </div>
      </v-toolbar>
    </div>

    <v-card class="ma-6">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        id="data_search"
        class="mx-4 pa-4"
        placeholder="検索"
        clearable
      ></v-text-field>

      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :custom-filter="customFilter"
        :items-per-page="100"
        :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
      >
        <template v-slot:item="{ item }">
          <tr :class="rowColorChange(item.del_flg)">
            <!-- 詳細アイコン、返信アイコン -->
            <td class="text-center">
              <div>
                <v-icon color="primary" @click="editItem(item)">mdi mdi-menu</v-icon>
              </div>
              <div>
                <v-icon
                  v-if="typeof item.child_array != 'undefined' && item.child_array.length > 0"
                  color="primary"
                  class="mb-2"
                  @click="editItem(item)"
                >mdi mdi-reply</v-icon>
              </div>
            </td>
            <!-- ユニークID、掲示板に表示されるID -->
            <td class="text-center">
              <span class="teal--text text--darken-4 caption">{{ item.unique_id }}</span>
              <v-divider></v-divider>
              <span class="teal--text text--darken-4 caption">{{ item.comment_id }}</span>
            </td>
            <!-- カテゴリ、記事番号 -->
            <td>
              <span class="teal--text text--darken-4 caption">{{ item.category_name }}</span>
              <v-divider></v-divider>
              <span class="teal--text text--darken-4 caption">{{ item.article_num }}</span>
            </td>
            <!-- 投稿日付やコメント内容など -->
            <td>
              <table class="main_table">
                <tr>
                  <th width="50">日付</th>
                  <td>
                    <span class="teal--text text--darken-4 caption">{{ item.create_date }}</span>
                  </td>
                  <th>投稿者</th>
                  <td>
                    <span class="teal--text text--darken-4 caption">{{ item.author_name }}</span>
                  </td>
                  <th>投稿者IP</th>
                  <td>
                    <span class="teal--text text--darken-4 caption">{{ item.author_ip }}</span>
                  </td>
                  <th>いいね</th>
                  <td>
                    <span class="teal--text text--darken-4 caption">{{ item.good_count }}</span>
                  </td>
                </tr>
                <tr>
                  <th>内容</th>
                  <td colspan="8" class="pt-4 pb-4">
                    <span class="font-weight-bold">{{ item.comment }}</span>
                  </td>
                </tr>
              </table>
            </td>
            <!-- 通報数 -->
            <td class="text-center">
              <div
                class="red--text text--red-accent-4 font-weight-bold"
                v-if="item.warn_count > 29"
                text
              >{{ item.warn_count }}</div>
              <div
                class="orange--text text--darken-2 font-weight-bold"
                v-else-if="item.warn_count > 0"
                text
              >{{ item.warn_count }}</div>
              <div v-else text>{{ item.warn_count }}</div>
            </td>
            <!-- 削除、復活アイコン -->
            <td class="text-center">
              <div>
                <v-icon
                  v-if="item.del_flg == 0 || item.del_flg == ''"
                  color="red"
                  @click="deleteItem(item, 'parent')"
                >mdi mdi-delete</v-icon>
                <v-icon
                  v-else
                  color="blue"
                  @click="restoreItem(item, 'parent')"
                >mdi mdi-delete-restore</v-icon>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- 編集画面 -->
    <v-row justify="center">
      <v-dialog v-model="dialog" scrollable persistent max-width="1500px">
        <v-card width="800" :disabled="loading">
          <v-overlay :absolute="true" :value="loading">
            <v-progress-circular :size="70" :width="7" color="yellow" indeterminate></v-progress-circular>
          </v-overlay>

          <v-card-title class="pa-0">
            <v-row class="pa-4 ml-1" style="width:100%">
              <v-col cols="3">投稿詳細</v-col>
              <v-col cols="7">
                <v-progress-circular v-if="loading" indeterminate width="15%"></v-progress-circular>
              </v-col>
              <v-col cols="2" class="text-right">
                <v-btn color="blue darken-1" text @click="closeDialog()" style="font-size:40px;">×</v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-tabs center-active v-model="tab" class="pl-4">
            <v-tab>返信一覧</v-tab>
            <v-tab>通報一覧</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab" class>
            <!-- 返信一覧 -->
            <v-tab-item>
              <div class="ma-5">
                <v-data-table :headers="headers3" :items="target_child_array">
                  <template v-slot:item="{ item }">
                    <tr :class="rowColorChange(item.del_flg)">
                      <td class="text-center">{{ item.create_date }}</td>
                      <td class="text-center">{{ item.author_name }}</td>
                      <td class="text-center">{{ item.author_ip }}</td>
                      <td>{{ item.comment }}</td>
                      <td class="text-center">{{ item.del_flg }}</td>
                      <td class="text-center">
                        <div>
                          <v-icon
                            v-if="item.del_flg == 0 || item.del_flg == ''"
                            color="red"
                            @click="deleteItem(item, 'child')"
                          >mdi mdi-delete</v-icon>
                          <v-icon
                            v-else
                            color="blue"
                            @click="restoreItem(item, 'child')"
                          >mdi mdi-delete-restore</v-icon>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-tab-item>
            <!-- 通報一覧 -->
            <v-tab-item>
              <div class="ma-5">
                <v-data-table :headers="headers2" :items="target_warn_list"></v-data-table>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
// Ajax通信ライブラリ
import axios from "axios";

export default {
  //===========================
  // dataは基本的に変数の定義とかやるやつっぽい
  //===========================
  data() {
    return {
      // 変数定義
      site_url: "",
      search: "",
      category: "",
      article_num: "",
      selectedItem: [],
      categoryItems: {},

      tab: null,

      loading: false,

      height: 0,
      dialog: false,

      // 投稿一覧ヘッダー(親コメ)
      headers: [
        {
          text: "詳細/返信",
          value: "del_flg",
          width: "5%",
          align: "center"
        },
        {
          text: "ID/表示ID",
          value: "comment_id",
          width: "10%",
          align: "center"
        },
        {
          text: "ｶﾃｺﾞﾘ/記事番",
          value: "category_name",
          width: "15%",
          align: "center"
        },
        { text: "コメント系", value: "comment", width: "60%" },
        {
          text: "通報",
          value: "warn_count",
          width: "5%",
          align: "center",
          color: "red-accent-4",
          fixed: true
        },

        { text: "削除/復活", value: "edit", width: "5%", align: "center" }
      ],
      // 通報一覧ヘッダー(親コメ)
      headers2: [
        { text: "通報日時", value: "create_date", width: "25%" },
        { text: "通報者IP", value: "ip_adress", width: "25%" },
        { text: "通報内容", value: "comment", width: "50%" }
      ],
      // 返信一覧ヘッダー(子コメ)
      headers3: [
        { text: "日付", value: "create_date", width: "15%" },
        { text: "名前", value: "author_name", width: "20%" },
        { text: "IP", value: "author_ip", width: "10%" },
        { text: "返信", value: "comment", width: "50%" },
        { text: "削除/復活", value: "edit", width: "5%", align: "center" }
      ],
      list: [],
      editedIndex: -1,
      editedItem: {
        id: "",
        category: "",
        title: "",
        source: "",
        memo: "",
        img_count: 0,
        imageData1: "",
        imageData2: ""
      },

      target_unique_id: "",
      target_author_name: "",
      target_requirements: "",
      target_comment_type: "",
      target_article_num: "",
      target_category: "",
      target_child_array: [],
      target_warn_list: []
    };
  },

  computed: {},

  //=======================================
  // 「created」はdom生成直前に呼ばれる
  // あらかじめ実行させておきたい処理はここに書く
  //=======================================
  created: function() {
    // セレクトボックスの値(カテゴリ、記事番号)を取得
    axios.get(process.env.VUE_APP_FBBS_DATA_LIST).then(response => {
      this.categoryItems = response.data;
    });
  },

  //===========================
  // メソッド定義
  //===========================
  methods: {
    //---------------------------
    // カスタムフィルタ
    // 検索用
    //---------------------------
    customFilter: function(items, search, target) {
      // console.log(items);
      // console.log(search);
      // console.log(target);

      var find_flg = false;

      if (target.comment_id.indexOf(search) != -1) {
        find_flg = true;
      }
      if (target.author_name.indexOf(search) != -1) {
        find_flg = true;
      }
      if (target.author_ip.indexOf(search) != -1) {
        find_flg = true;
      }
      if (target.create_date.indexOf(search) != -1) {
        find_flg = true;
      }
      if (target.comment.indexOf(search) != -1) {
        find_flg = true;
      }

      if (find_flg) {
        return find_flg;
      }
    },

    //---------------------------
    // カテゴリ、記事番号選択
    //---------------------------
    selected: function() {
      this.article_num = "";
      this.selectedItem = this.categoryItems[this.category];
      this.site_url = process.env.VUE_APP_DOMAIN_URL;
    },

    //---------------------------
    // データ取得
    //---------------------------
    dataSearch: function() {
      axios
        .get(
          process.env.VUE_APP_FBBS_LIST +
            "?category=" +
            this.category +
            "&article_num=" +
            this.article_num
        )
        .then(response => {
          // v-data-tableを使うときは配列に格納する
          var items = [];
          var values = Object.values(response.data.parent);
          var child = response.data.child;

          var push_array = {};
          var child_array = [];

          // 親コメントに返信があれば入れる
          values.forEach(value => {
            child_array = [];
            if (child[value.comment_id] != null) {
              child[value.comment_id].forEach(child_value => {
                if (child_value["article_num"] == value.article_num) {
                  child_array.push(child_value);
                }
              });
            }

            // console.log(child_array);

            push_array = {
              unique_id: value.unique_id,
              article_num: value.article_num,
              comment_id: value.comment_id,
              category_name: value.category_name,
              author_name: value.author_name,
              author_ip: value.author_ip,
              create_date: value.create_date,
              requirements: value.requirements,
              comment: value.comment,
              img: value.img,
              good_count: value.good_count,
              warn_count: value.warn_count,
              del_flg: value.del_flg,
              child_array: child_array
            };

            items.push(push_array);
          });

          this.list = items;
        });
    },

    //---------------------------
    // 該当ページのキャッシュファイル削除
    //---------------------------
    cacheClear: function() {
      var result = confirm("このページのキャッシュを飛ばしますか？");
      // console.log(this.category);
      // console.log(this.article_num);
      if (result == false) {
        return;
      }

      axios
        .get(
          process.env.VUE_APP_FBBS_CACHE_CLEAR +
            "?category=" +
            this.category +
            "&article_num=" +
            this.article_num
        )
        .then(response => {
          alert("キャッシュを削除しました！");
          console.log(response);
        });
    },

    // // jsonを配列にするテスト
    // checkJsonFormat(value) {
    //   try {
    //     JSON.parse(value);
    //     return true;
    //   } catch (error) {
    //     return false;
    //   }
    // },

    //---------------------------
    // 削除済みをグレーアウト
    //---------------------------
    rowColorChange(value) {
      let bgc = value != 0 ? "deleted" : "";
      // console.log(bgc);
      return bgc;
    },

    //---------------------------
    // 投稿クリック時(詳細画面開く)
    //---------------------------
    editItem(item) {
      this.editedIndex = this.list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;

      this.target_unique_id = item.unique_id;
      this.target_author_name = item.author_name;
      this.target_comment_type = item.type;
      this.target_requirements = item.title;
      this.target_article_num = item.article_num;
      this.target_category = item.category;
      this.target_child_array = item.child_array;

      this.target_warn_list = [];

      axios
        .get(
          process.env.VUE_APP_FBBS_WARN + "?parent_id=" + this.target_unique_id
        )
        .then(response => {
          const values = Object.values(response.data);

          values.forEach(value => {
            this.target_warn_list.push(value);
          });
        });
    },

    //---------------------------
    // 詳細モーダル閉じる
    //---------------------------
    closeDialog() {
      this.dialog = false;
    },

    //---------------------------
    // 投稿削除
    //---------------------------
    deleteItem(item, comment_type) {
      var result = confirm("このコメントを削除しますか？");
      // console.log(item);
      if (result == false) {
        return;
      }

      item.del_flg = 1;
      item.update_type = "delete";
      item.type = comment_type;

      var self = this;
      axios
        .post(process.env.VUE_APP_FBBS_UPDATE, {
          data: item
        })
        .then(function(response) {
          console.log(response);
          alert("コメントを削除しました！");
          self.close();
        });
    },

    //---------------------------
    // 投稿復活
    //---------------------------
    restoreItem(item, comment_type) {
      var result = confirm("このコメントを復活させますか？");
      // console.log(item);
      if (result == false) {
        return;
      }

      item.del_flg = 0;
      item.update_type = "restore";
      item.type = comment_type;

      var self = this;
      axios
        .post(process.env.VUE_APP_FBBS_UPDATE, {
          data: item
        })
        .then(function(response) {
          console.log(response);
          alert("コメントを復活させました！");
          self.close();
        });
    },

    //---------------------------
    // 確認ダイアログ閉じる
    //---------------------------
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    }
  }
};
</script>

<style>
.deleted td {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd !important;
}
.v-data-table th span {
  font-size: 12px !important;
}

.v-data-table table th {
  font-weight: normal;
  color: #888;
}

.v-data-table td,
.v-data-table th {
  padding: 2px;
  height: 30px !important;
}
.v-data-table tr:last-child td,
.v-data-table tr:last-child th {
  border: none;
}
table tr:nth-child(odd) td {
  background: #fbf9ff;
}
.main_table td,
.main_table th {
  background: transparent !important;
}

.main_table tr:last-child th,
.main_table tr:last-child td {
  border: none !important;
}
</style>